<template>
    <vs-card>
        <vs-tabs v-model="$route.params.tabIndex">
            <vs-tab label="Platform Settings">
                <div>
                    <PlatformSettings :tabIndex="tabIndex" />
                </div>
            </vs-tab> 
            <vs-tab label="School Settings">
                <div>
                    <SchoolSettings />
                </div>
            </vs-tab> 
            <vs-tab label="User Settings">
                <div>
                    <UserSettings />
                </div>
            </vs-tab> 
            <vs-tab label="Connected Apps">
                <div>
                    <ConnectedApps />
                </div>
            </vs-tab> 
        </vs-tabs>
    </vs-card>
</template>

<script>
import PlatformSettings from './components/platform/index.vue'
import SchoolSettings from './components/school/index.vue'
import UserSettings from '@/views/pages/roleManagement/index.vue'
import ConnectedApps from './components/connected_app/index.vue'

export default {
  data () {
    return {
      tabIndex:0
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.from = from
      console.log(from.fullPath.includes('statusmanagement'))
      if (from.fullPath.includes('customvaluesettings') || from.fullPath.includes('filterlist') || from.fullPath.includes('Field-management')
    || from.fullPath.includes('statusmanagement')) { 
        vm.tabIndex = 2 
      }
    })
  },
  components: {
    PlatformSettings,
    SchoolSettings,
    UserSettings,
    ConnectedApps
  }
}
</script>